import React, { useState } from 'react';
import kvbImage from '../images/kvb-2026.jpeg';
import image1 from '../images/KVB-2026-01.jpeg';
import image2 from '../images/KVB-2026-02.jpeg';

const KarkidakaVavuBali2026 = () => {
    const [selectedImage, setSelectedImage] = useState(null);

    return (
        <>
            <div className='container mx-auto'>
                <section className='py-5 px-4 flex flex-col-reverse lg:flex-row items-center justify-between'>
                    <div className="lg:w-1/2 text-center lg:text-left mt-5 mr-2">
                        <h1 className='text-xl lg:text-2xl font-bold text-gray-800 mb-6'>Karkidaka Vavu Bali 2026</h1>
                        <p className='mb-6'>മാന്യരാമധർമ പ്രചാരസഭ കുടുംബ അംഗങ്ങൾക്ക് നമസ്തെ</p>
                        <p>കർക്കിടക വാവ് ബലി പിതൃക്കളുടെ അനുഗ്രത്താൽ വളരെ നല്ലരീതിയിൽ നടത്തുവാൻ സാധിച്ചു.
                            മുൻ കാലങ്ങളെപ്പോലെ മാന്യ
                            ആർഎസ്എസ് അധികാരികളുടെ സഹകരണത്തോടെയും, രാമധർമ്മപ്രചാരസഭ യുടെ പ്രവർത്തകരും ബാലഗോകുലം  കുടുംബ അംഗങ്ങളുംമറ്റ് പരിവാർ പ്രസ്ഥാനങ്ങളുടെ പ്രവർത്തകരും,കോർപറേറ്റർ മാർ,
                            പൊലീസ് വകുപ്പ്, കാപ്ര GHMC, ടീം വിശിഷ്യ കമലാനഗർ  അയ്യപ്പ ക്ഷേത്രത്തിലെ കാരണവർമ്മാരും മറ്റ് സഹപ്രവർത്തകരും ഒത്തൊരുമയോടെ അഹോരാത്രം പ്രവർത്തിച്ചതിൻ്റെ ഫലമായാണ്  വളരെ നല്ലരീതിയിൽ പൂർത്തിയാക്കുവാൻ സാധിച്ചത് .</p>
                        <p className='mt-5'>എല്ലാപേർക്കും
                            പിതൃക്കളുടെ അനുഗ്രഹത്തിനായി പ്രാർത്ഥിക്കുന്നു. സഹരിച്ച എല്ലാപേർക്കും നന്ദിയോടൊപ്പം സ്നേഹവും അറിയിക്കുന്നു .</p>
                        <p className='mt-5'>രാമധർമപ്രചാരസഭയ്ക്കുവേണ്ടി.<br />
                            പ്രസിഡൻ്റ്, സെക്രെട്ടറി,
                            ട്രഷറർ.</p>
                    </div>
                    <div className="lg:w-1/2">
                        <img
                            src={kvbImage}
                            alt="Karkidaka Vavubali"
                            className="rounded-lg shadow-lg object-cover"
                        />
                    </div>
                </section>
                <div className="px-6">
                    {/* --- Responsive Image Thumbnails Grid --- */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                        <div
                            className="cursor-pointer overflow-hidden rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow"
                            onClick={() => setSelectedImage(image1)}
                        >
                            <img
                                src={image1}
                                alt="Charity"
                                className="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
                            />
                        </div>

                        <div
                            className="cursor-pointer overflow-hidden rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow"
                            onClick={() => setSelectedImage(image2)}
                        >
                            <img
                                src={image2}
                                alt="Charity"
                                className="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
                            />
                        </div>
                    </div>
                </div>
                <section className='py-5 px-4 flex flex-col-reverse lg:flex-row items-center justify-between'>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/65s4QG2Ytao?si=C76WKtMSvgqh0EMF" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </section>
                <section className='py-5 px-4 flex flex-col-reverse lg:flex-row items-center justify-between'>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/pKc7EQgJRog?si=v5wsB-WtxkXuOYrP" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </section>
            </div>
            {/* --- Modal / Lightbox for Enlarged View --- */}
            {selectedImage && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4 transition-opacity"
                    onClick={() => setSelectedImage(null)} // Click anywhere backdrop to close
                >
                    <div className="relative max-w-3xl max-h-[90vh] p-2 bg-white rounded-lg shadow-2xl">
                        {/* Close button */}
                        <button
                            className="absolute -top-3 -right-3 bg-red-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold hover:bg-red-700 shadow-lg"
                            onClick={() => setSelectedImage(null)}
                        >
                            ✕
                        </button>

                        {/* Full Size Image */}
                        <img
                            src={selectedImage}
                            alt="Enlarged view"
                            className="max-w-full max-h-[80vh] object-contain rounded"
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default KarkidakaVavuBali2026;